import { Step } from "react-joyride";

const confirmProposalModalTourSteps: Step[] = [
  {
    target: ".tour-proposal-format",
    content: "Here you can change the format of this proposal which is shown to the customer.",
  },
  {
    target: ".tour-main-recipient",
    content: "This is the recipient's email from the Contact that was chosen.",
  },
  {
    target: ".tour-additional-recipients",
    content: "You can include additional recipients for the proposal.",
  },
  {
    target: ".tour-email-settings",
    content:
      "This is the subject line and text of the email being sent to the customer with the proposal link.",
  },
];

export default confirmProposalModalTourSteps;
